import { IconButton } from "@mui/material";
import styled from "styled-components";

export const StyleZoomLevels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  height: 35px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  opacity: 1;
`;

export const TopPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;

export const BottomPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftAlignedText = styled.div`
  text-align: left;
  font: normal normal 600 13px/18px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
`;

export const DiveTags = styled.div`
  fontSize: small;
  color: gray;
`;

export const ZoomIconButton = styled(IconButton)`
  padding: 6px;
`;
